export default {
	title: 'ملخص اليوم',
	sales: 'المبيعات',
	returns: 'مرتجعات',
	customer: 'الزبون',
	quantity: 'الكمية',
	'package-price': 'سعر الطرد',
	'total-price': 'إجمالي السعر',
	time: 'الوقت',
	'total-amount': 'المبلغ الكلي',
	'grand-total': 'الإجمالي',
	'unknown-material': 'مادة غير معروفة',
	'unknown-customer': 'زبون غير معروف',
	'no-data': 'لا توجد حركات لهذا اليوم',
}
